import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '@/components/feature/Navigation';
import SEOHead from '@/components/feature/SEOHead';
import PressHero from './components/PressHero';
import PressCoverage from './components/PressCoverage';
import PressContactForm from './components/PressContactForm';

const pressSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://oludamolaadebowale.com/press#presspage',
  url: 'https://oludamolaadebowale.com/press',
  name: 'Press and Media, Oludamola Adebowale',
  description:
    'Press coverage and media enquiries for Nigerian cultural historian, curator, and archivist Oludamola Adebowale. Features coverage from BBC, CNN, The Guardian Nigeria, and ThisDay Live.',
  mainEntity: { '@id': 'https://oludamolaadebowale.com/#person' },
  about: { '@id': 'https://oludamolaadebowale.com/#person' },
  inLanguage: 'en',
  dateModified: '2026-04-05',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://oludamolaadebowale.com/' },
      { '@type': 'ListItem', position: 2, name: 'Press', item: 'https://oludamolaadebowale.com/press' },
    ],
  },
};

export default function PressPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash === '#contact') {
      // Small delay to allow page to render before scrolling
      const timer = setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 150);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [hash]);

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Press and Media | Oludamola Adebowale, CNN, BBC, The Guardian Nigeria"
        description="Press coverage and media enquiries for Oludamola Adebowale, Nigerian cultural historian and archivist. Featured by CNN, The Guardian Nigeria, ThisDay Live, and more. Response within 48 hours."
        keywords="Oludamola Adebowale press, CNN Nigeria heritage, Guardian Nigeria cultural historian, Nigerian archivist media, press enquiries Lagos Nigeria"
        canonical="https://oludamolaadebowale.com/press"
        ogType="website"
        schemaJson={pressSchema}
      />
      <Navigation />
      <div className="pt-20">
        <PressHero />
        <PressCoverage />
        <PressContactForm />

        <div className="bg-[#f9f6f1] border-t border-stone-200 py-12">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <p className="font-sans text-sm text-gray-500">
              All press enquiries are handled personally. Response time is typically within 48 hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}